import type { GardenMetric, GraphLink, Moment, MomentCategory, NoteCard, SourceNode } from "../types";

export const sourceNodes: SourceNode[] = [
  {
    id: "course_ontology",
    title: "Ontology for Knowledge Apps",
    kind: "course",
    progress: 42,
    status: "in_progress",
    tags: ["tech", "ai"],
    noteCount: 18,
    createdAt: "24/05/2026 09:00",
    lastTouched: "Hôm nay",
    noteActivityAt: "2026-05-24T13:18:00.000Z",
    sourceUpdatedAt: "2026-05-24T09:00:00.000Z"
  },
  {
    id: "module_modeling",
    title: "Module 1: Modeling primitives",
    kind: "module",
    parentId: "course_ontology",
    progress: 64,
    status: "in_progress",
    tags: ["tech", "ai"],
    noteCount: 8,
    createdAt: "24/05/2026 09:12",
    lastTouched: "Hôm nay",
    noteActivityAt: "2026-05-24T12:40:00.000Z",
    sourceUpdatedAt: "2026-05-24T09:12:00.000Z"
  },
  {
    id: "lesson_relation",
    title: "Lesson: Relation as first-class object",
    kind: "lesson",
    parentId: "module_modeling",
    progress: 75,
    status: "in_progress",
    noteCount: 5,
    createdAt: "24/05/2026 09:25",
    lastTouched: "2 giờ trước",
    noteActivityAt: "2026-05-24T13:18:00.000Z",
    sourceUpdatedAt: "2026-05-24T09:25:00.000Z"
  },
  {
    id: "book_how_to_take_smart_notes",
    title: "How to Take Smart Notes",
    kind: "book",
    progress: 28,
    status: "not_started",
    tags: ["learning"],
    noteCount: 11,
    createdAt: "23/05/2026 20:10",
    lastTouched: "Hôm qua",
    noteActivityAt: "2026-05-23T21:05:00.000Z",
    sourceUpdatedAt: "2026-05-23T20:10:00.000Z"
  },
  {
    id: "article_pkms",
    title: "Article: Networked PKM patterns",
    kind: "article",
    progress: 100,
    status: "completed",
    tags: ["tech", "research"],
    noteCount: 6,
    createdAt: "21/05/2026 16:45",
    lastTouched: "3 ngày trước",
    noteActivityAt: "2026-05-21T16:45:00.000Z",
    sourceUpdatedAt: "2026-05-21T16:45:00.000Z"
  },
  {
    id: "output_relation_essay",
    title: "Bài viết: Vì sao liên kết cần provenance",
    kind: "output",
    progress: 100,
    status: "completed",
    properties: { platform: "Substack", author: "me", sourceUrl: "https://example.substack.com/p/provenance" },
    noteCount: 0,
    createdAt: "25/05/2026 08:00",
    lastTouched: "Hôm nay",
    noteActivityAt: null,
    sourceUpdatedAt: "2026-05-25T08:00:00.000Z"
  }
];

export const notes: NoteCard[] = [
  {
    id: "note_relation_object",
    title: "Quan hệ cũng cần provenance",
    kind: "note",
    sourceId: "lesson_relation",
    content:
      "Một liên kết trong Human Note không chỉ là cạnh graph. Nó cần lý do, nguồn, độ tin cậy và ngữ cảnh học.",
    relationCount: 7,
    reviewCount: 3,
    attachmentCount: 0,
    status: "budding",
    tags: ["tech", "ai"],
    createdAt: "24/05/2026 13:18",
    updatedAt: "13:18"
  },
  {
    id: "task_schema_seed",
    title: "Seed relation types cho MVP",
    kind: "task",
    sourceId: "module_modeling",
    content: "Tạo bộ relation mặc định: belongs_to, cites, supports, contradicts, turns_into_task.",
    relationCount: 4,
    reviewCount: 1,
    attachmentCount: 0,
    status: "doing",
    createdAt: "24/05/2026 12:40",
    updatedAt: "12:40"
  },
  {
    id: "quote_atomic_note",
    title: "Atomicity giúp note tái dùng",
    kind: "quote",
    sourceId: "book_how_to_take_smart_notes",
    content: "Quote được giữ riêng khỏi suy ngẫm để tránh trộn nguồn với diễn giải cá nhân.",
    relationCount: 5,
    reviewCount: 4,
    attachmentCount: 0,
    status: "applied",
    tags: ["learning"],
    createdAt: "23/05/2026 21:05",
    updatedAt: "Hôm qua"
  },
  {
    id: "exercise_source_tree",
    title: "Bài tập: dựng cây khóa học từ mục lục",
    kind: "exercise",
    sourceId: "course_ontology",
    content: "Nhập title + module; hệ thống tạo source hierarchy và gợi ý node bị thiếu.",
    relationCount: 3,
    reviewCount: 2,
    attachmentCount: 0,
    status: "todo",
    createdAt: "23/05/2026 18:20",
    updatedAt: "Hôm qua"
  },
  {
    id: "critique_relation_overhead",
    title: "Phản biện: relation có provenance thì quá nặng để nhập tay",
    kind: "critique",
    sourceId: "lesson_relation",
    content: "Bắt mỗi liên kết phải có lý do + nguồn + độ tin cậy sẽ làm người dùng ngại tạo liên kết. Cần mặc định nhẹ.",
    relationCount: 2,
    reviewCount: 1,
    attachmentCount: 0,
    status: "arguing",
    createdAt: "24/05/2026 09:40",
    updatedAt: "Hôm nay"
  },
  {
    id: "expansion_provenance_layers",
    title: "Mở rộng: các tầng provenance cho một liên kết",
    kind: "expansion",
    sourceId: "lesson_relation",
    content: "Đào sâu ý provenance: nguồn trực tiếp, nguồn suy luận, độ tin cậy theo thời gian, và ai/khi nào tạo ra liên kết.",
    relationCount: 4,
    reviewCount: 2,
    attachmentCount: 0,
    status: "expanding",
    createdAt: "24/05/2026 10:05",
    updatedAt: "Hôm nay"
  }
];

export const gardenMetrics: GardenMetric[] = [
  { label: "Notes", value: "40", delta: "+9 tuần này" },
  { label: "Liên kết", value: "126", delta: "+31 liên kết mới" },
  { label: "Ôn lại", value: "18", delta: "7 note cũ được làm giàu" },
  { label: "Nguồn học", value: "5", delta: "2 nguồn đang mở" }
];

export const graphLinks: GraphLink[] = [
  { from: "Relation", to: "Provenance", label: "requires" },
  { from: "Quote", to: "Source anchor", label: "cites" },
  { from: "Task", to: "Practice", label: "turns into" },
  { from: "Course", to: "Module", label: "contains" },
  { from: "Reflection", to: "Concept", label: "enriches" }
];

// Offline mock for the Moments side-branch (mirrors the API JSON shape). Flat rows so the client
// can run buildCategoryTree() on them exactly like the real /api/moment-categories response.
export const sampleMomentCategories: MomentCategory[] = [
  { id: "cat_routine", parentId: null, kind: "routine", name: "Nếp sinh hoạt", icon: "Sun", color: null, sortOrder: 0, isSystem: true, status: "active" },
  { id: "cat_wake", parentId: "cat_routine", kind: "routine", name: "Thức dậy", icon: "Sunrise", color: null, sortOrder: 0, isSystem: false, status: "active" },
  { id: "cat_breakfast", parentId: "cat_routine", kind: "routine", name: "Ăn sáng", icon: "Coffee", color: null, sortOrder: 1, isSystem: false, status: "active" },
  { id: "cat_lunch", parentId: "cat_routine", kind: "routine", name: "Ăn trưa", icon: "Utensils", color: null, sortOrder: 2, isSystem: false, status: "active" },
  { id: "cat_dinner", parentId: "cat_routine", kind: "routine", name: "Ăn tối", icon: "UtensilsCrossed", color: null, sortOrder: 3, isSystem: false, status: "active" },
  { id: "cat_sleep", parentId: "cat_routine", kind: "routine", name: "Đi ngủ", icon: "Moon", color: null, sortOrder: 4, isSystem: false, status: "active" },
  { id: "cat_habit", parentId: null, kind: "habit", name: "Thói quen", icon: "Target", color: null, sortOrder: 1, isSystem: true, status: "active" },
  { id: "cat_reading", parentId: "cat_habit", kind: "habit", name: "Đọc sách", icon: "BookOpen", color: null, sortOrder: 0, isSystem: false, status: "active" },
  { id: "cat_exercise", parentId: "cat_habit", kind: "habit", name: "Tập thể dục", icon: "Dumbbell", color: null, sortOrder: 1, isSystem: false, status: "active" }
];

export const sampleMoments: Moment[] = [
  {
    id: "moment_sample_1",
    categoryId: "cat_breakfast",
    loggedAt: "2026-07-01T01:20:00.000Z",
    localDay: "2026-07-01",
    note: "Phở bò sáng nay",
    photoUrl: null,
    contentType: null,
    sizeBytes: 0,
    createdAt: "2026-07-01T01:20:00.000Z",
    category: { id: "cat_breakfast", name: "Ăn sáng", kind: "routine", icon: "Coffee" }
  },
  {
    id: "moment_sample_2",
    categoryId: "cat_reading",
    loggedAt: "2026-06-30T14:05:00.000Z",
    localDay: "2026-06-30",
    note: "Đọc 20 trang Atomic Habits",
    photoUrl: null,
    contentType: null,
    sizeBytes: 0,
    createdAt: "2026-06-30T14:05:00.000Z",
    category: { id: "cat_reading", name: "Đọc sách", kind: "habit", icon: "BookOpen" }
  }
];
